import { learningServiceRequest } from "./utils";

const courseApprovalService = {
  async addOrUpdateCourseApproval(updatedCourseApproval) {
    if (updatedCourseApproval.id) {
      return await learningServiceRequest({
        method: "put",
        url: `/ci/ci_equivalents/${updatedCourseApproval.id}`,
        payload: updatedCourseApproval,
      });
    } else {
      return await learningServiceRequest({
        method: "post",
        url: `/ci/ci_equivalents`,
        payload: updatedCourseApproval,
      });
    }
  },

  async deleteCourse(deleteId) {
    return await learningServiceRequest({
      method: "delete",
      url: `/ci/ci_equivalents/${deleteId}`,
    });
  },
};

export default courseApprovalService;
